import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { SupportRoutingModule } from './support-routing.module';
import { ReactiveFormsModule } from '@angular/forms';
import { GeneralModule } from '../general/general.module';
import { GeneralTicketComponent } from './general-ticket/general-ticket.component';
import { NgSelectModule } from '@ng-select/ng-select';
import { SupportFormComponent } from './support-form/support-form.component';
import { FiatDepositTicketComponent } from './fiat-deposit-ticket/fiat-deposit-ticket.component';
import { BankDetailsTicketComponent } from './bank-details-ticket/bank-details-ticket.component';
import { PhoneChangeTicketComponent } from './phone-change-ticket/phone-change-ticket.component';
import { PipesModule } from '../pipes/pipes.module';
import { CitizenshipResidencyValidationTicketComponent } from './citizenship-residency-validation-ticket/citizenship-residency-validation-ticket.component';
import { ContactCardComponent } from './contact-card/contact-card.component';
import { OtcTicketComponent } from './otc-ticket/otc-ticket.component';

@NgModule({
  declarations: [
    GeneralTicketComponent,
    SupportFormComponent,
    FiatDepositTicketComponent,
    BankDetailsTicketComponent,
    PhoneChangeTicketComponent,
    CitizenshipResidencyValidationTicketComponent,
    ContactCardComponent,
    OtcTicketComponent
  ],
  imports: [
    CommonModule,
    SupportRoutingModule,
    ReactiveFormsModule,
    NgSelectModule,
    GeneralModule,
    PipesModule
  ],
  exports: [
    SupportFormComponent,
    ContactCardComponent
  ]
})
export class SupportModule { }
